import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitGhostwriterApplicationMutationVariables = Types.Exact<{
  input: Types.GhostwriterSubmitApplicationInput;
}>;


export type SubmitGhostwriterApplicationMutation = { __typename?: 'Mutation', ghostwriter: { __typename?: 'GhostwriterMutations', submitApplication: { __typename?: 'SubmitGhostwriterApplicationPayload', taskId?: string | null, application?: { __typename?: 'GhostwriterApplication', id: string, applicationStatus: Types.GhostwriterApplicationStatus } | null, userErrors: Array<{ __typename?: 'GhostwriterUserError', message: string, field?: Array<string> | null, code?: string | null }> } } };


export const SubmitGhostwriterApplicationDocument = gql`
    mutation SubmitGhostwriterApplication($input: GhostwriterSubmitApplicationInput!) {
  ghostwriter {
    submitApplication(input: $input) {
      application {
        id
        applicationStatus
      }
      taskId
      userErrors {
        message
        field
        code
      }
    }
  }
}
    `;
export type SubmitGhostwriterApplicationMutationFn = Apollo.MutationFunction<SubmitGhostwriterApplicationMutation, SubmitGhostwriterApplicationMutationVariables>;

/**
 * __useSubmitGhostwriterApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitGhostwriterApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGhostwriterApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGhostwriterApplicationMutation, { data, loading, error }] = useSubmitGhostwriterApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitGhostwriterApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitGhostwriterApplicationMutation, SubmitGhostwriterApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitGhostwriterApplicationMutation, SubmitGhostwriterApplicationMutationVariables>(SubmitGhostwriterApplicationDocument, options);
      }
export type SubmitGhostwriterApplicationMutationHookResult = ReturnType<typeof useSubmitGhostwriterApplicationMutation>;
export type SubmitGhostwriterApplicationMutationResult = Apollo.MutationResult<SubmitGhostwriterApplicationMutation>;
export type SubmitGhostwriterApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitGhostwriterApplicationMutation, SubmitGhostwriterApplicationMutationVariables>;